import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSession } from '../SessionContext';

// Checks if the user is logged in, if not the user is redirected to the login page
const PrivateRoute = (props) => {
    const { isLoggedIn } = useSession();

    return (
        <Route
            render={() => (
                isLoggedIn ?
                    <props.component {...props} /> :
                    <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            )}
        />
    );
}

export default PrivateRoute;